export const ConnexionTitle = 'Veuillez vous connecter pour pouvoir accéder à cette fonctionnalité ';
